import React from "react";
import "./App.css";
import Method1 from "./Method1";
import Method2 from "./Method2";
import Method3 from "./Method3";

function App() {
 

  return (
    <div className='App'>
      <h4>نرم افزار محاسبه نمره دروس مهارتی</h4>
      <Method1 />
      <div className="twoMethods">
        <Method2 />
        <Method3 />
      </div>
<h6>بهار 1399 - سجاد ناصری زاده - 09166505841</h6>      

    </div>
  );
}

export default App;
